import { render } from "./CollaboratorAvatar.vue?vue&type=template&id=09604111&scoped=true"
import script from "./CollaboratorAvatar.vue?vue&type=script&lang=js"
export * from "./CollaboratorAvatar.vue?vue&type=script&lang=js"

import "./CollaboratorAvatar.vue?vue&type=style&index=0&id=09604111&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09604111"]])

export default __exports__